angular.module('impactx.productgroup').controller('ProductGroupNestedTreeListCtrl', [ProductGroupNestedTreeListCtrl]);

function ProductGroupNestedTreeListCtrl() {
    var self = this;

    self.expandSub = function (event, entry) {
        if (entry.isLeaf) {
            event.stopPropagation();
            event.preventDefault();
        }
        else {
            self.expand({event: event, entry: entry});
        }
    };

    self.addSub = function (event, entry) {
        self.addEntry({event: event, entry: entry});
    };

    self.editSub = function (event, entry) {
        self.editEntry({event: event, entry: entry});
    };

    self.deleteSub = function (event, entry) {
        self.deleteEntry({event: event, entry: entry});
    };

    self.editPriceSub = function (event, entry) {
        self.editPriceEntry({event: event, entry: entry});
    };

    self.exportArticleSheetSub = function (event, entry) {
        self.exportArticleSheet({event: event, entry: entry});
    };

}